import i18n from '@/i18n'

const header = [
	{
		'name': i18n.t('goods_detail.menu.goods'),
		'id': 0,
		'isActive': false
	},
	// {
	// 	'name': i18n.t('goods_detail.menu.detail'),
	// 	'id': 1,
	// 	'isActive': false
	// },
	{
		'name': i18n.t('goods_detail.menu.evaluation'),
		'id': 2,
		'isActive': false
	}
];

const evaluation = [
	{
		'name': i18n.t('goods_detail.evaluation.all'),
		'id': 1,
		'isActive': false,
		'value': 'total',
		'grade': 0
	},
	{
		'name': i18n.t('goods_detail.evaluation.good'),
		'id': 2,
		'isActive': false,
		'value': 'good',
		'grade': 1
	},
	{
		'name': i18n.t('goods_detail.evaluation.medium'),
		'id': 3,
		'isActive': false,
		'value': 'medium',
		'grade': 2
	},
	{
		'name': i18n.t('goods_detail.evaluation.bad'),
		'id': 4,
		'isActive': false,
		'value': 'bad',
		'grade': 3
	}
];
export {
	header,
	evaluation
}
